module.exports = __webpack_public_path__ + "static/img/invoice-web.bfc27a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invoice-web.png
// module id = AIkk
// module chunks = 73